// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2aKdq","content":"Consent_content__3FVXT","footer":"Consent_footer__3Sivk"};